<div class="checkout-stepper-spacer" aria-hidden="true"></div>

<nav class="checkout-stepper" aria-label="Checkout progress">
  <div class="checkout-stepper__track" aria-hidden="true">
    <div class="checkout-stepper__track-bg"></div>
    <div
      class="checkout-stepper__track-fill"
      [style.width.%]="progressPercent">
    </div>
  </div>

  <ol class="checkout-stepper__list">
    <li
      *ngFor="let stepDef of stepDefs"
      class="checkout-stepper__item"
      [class.is-completed]="getStepState(stepDef.id) === 'completed'"
      [class.is-active]="getStepState(stepDef.id) === 'active'"
      [class.is-upcoming]="getStepState(stepDef.id) === 'upcoming'"
      [attr.aria-current]="getStepState(stepDef.id) === 'active' ? 'step' : null">

      <div class="checkout-stepper__indicator">
        <svg
          *ngIf="getStepState(stepDef.id) === 'completed'; else stepNumber"
          class="checkout-stepper__check"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="3"
          aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
        </svg>

        <ng-template #stepNumber>
          <span class="checkout-stepper__number">{{ stepDef.id }}</span>
        </ng-template>
      </div>

      <p class="checkout-stepper__label">
        {{ getStepLabel(stepDef.labelKey) }}
      </p>
    </li>
  </ol>
</nav>
